// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1jPs1","subtitle":"Title_subtitle__2Oxhx"};